import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Bird from "../../assets/images/bird.jpg";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js"; // Importera CryptoJS
import Navbar from "../../components/layout/Navbar";

/**
 * React component for user sign-up.
 * @returns {JSX.Element}
 * @constructor
 */
export default function SignUp() {
    const history = useHistory();
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const secretKey = "din-hemliga-nyckel"; // TODO Ändra detta till en säker nyckel

    // Funktion för att kryptera cookies
    const encryptCookie = (value) => {
        return CryptoJS.AES.encrypt(value, secretKey).toString();
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        const data = new FormData(event.currentTarget);
        const user = {
            firstname: data.get("firstname"),
            lastname: data.get("lastname"),
            email: data.get("email"),
            password: data.get("password"),
        };

        try {

            //const token = await getToken();
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/register`, {
                method: 'POST',
                credentials: 'include', //TODO I donät think this should be here since the user can't have any credentials until AFTER succesful signup
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify(user),
            });

            if (!response.ok) {
                const errorText = await response.text();
                setErrorMessage("Registreringen misslyckades: " + errorText);
                setIsLoading(false);
                throw new Error(`Registration failed: ${errorText}`);
            }
            const encryptedValue = encryptCookie("USER");
            Cookies.set("access", encryptedValue, { secure: true, sameSite: "Strict" });
            history.push("/");
        } catch (error) {
            setErrorMessage("Ett fel inträffade vid registrering, vänligen försök igen.");
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-sage font-body pt-16">
            
            <Navbar />

            <div className="flex items-center justify-center min-h-[calc(100vh-4rem)] p-4">
                <div className="w-full md:max-w-md bg-offwhite md:shadow-lg md:rounded-lg overflow-hidden">
                
                {/* Form Section */}
                <div className="w-full bg-offwhite flex items-center justify-center">
                    <div className="w-full max-w-md px-6 py-8">
                        <div className="flex flex-col items-center">
                            {/* Lock Icon */}
                            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-forest mb-4">
                                <svg className="w-6 h-6 text-offwhite" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                </svg>
                            </div>
                            
                            <h1 className="text-2xl font-heading font-semibold text-charcoal mb-6">
                                Registrera Konto
                            </h1>
                            
                            <form onSubmit={handleSubmit} className="w-full mt-4">
                                <div className="mb-4">
                                    <label htmlFor="firstname" className="block text-sm font-medium text-charcoal mb-1">
                                        Förnamn *
                                    </label>
                                    <input
                                        type="text"
                                        id="firstname"
                                        name="firstname"
                                        autoComplete="given-name"
                                        required
                                        autoFocus
                                        className="w-full px-3 py-2 border border-sage rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-forest focus:border-forest bg-white"
                                    />
                                </div>
                                
                                <div className="mb-4">
                                    <label htmlFor="lastname" className="block text-sm font-medium text-charcoal mb-1">
                                        Efternamn *
                                    </label>
                                    <input
                                        type="text"
                                        id="lastname"
                                        name="lastname"
                                        autoComplete="family-name"
                                        required
                                        className="w-full px-3 py-2 border border-sage rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-forest focus:border-forest bg-white"
                                    />
                                </div>
                                
                                <div className="mb-4">
                                    <label htmlFor="email" className="block text-sm font-medium text-charcoal mb-1">
                                        E-postadress *
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        autoComplete="email"
                                        required
                                        className="w-full px-3 py-2 border border-sage rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-forest focus:border-forest bg-white"
                                    />
                                </div>
                                
                                <div className="mb-4">
                                    <label htmlFor="password" className="block text-sm font-medium text-charcoal mb-1">
                                        Lösenord (Minst 8 karaktärer) *
                                    </label>
                                    <input
                                        type="password"
                                        id="password"
                                        name="password"
                                        autoComplete="new-password"
                                        required
                                        className="w-full px-3 py-2 border border-sage rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-forest focus:border-forest bg-white"
                                    />
                                </div>
                                
                                {errorMessage && (
                                    <p className="text-red-600 text-sm mb-4">
                                        {errorMessage}
                                    </p>
                                )}
                                
                                <button
                                    type="submit"
                                    disabled={isLoading}
                                    className={`w-full bg-leaf text-offwhite py-2 px-4 rounded-md hover:bg-forest transition-colors duration-200 mt-6 mb-2 font-medium ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                                >
                                    {isLoading ? "Registrerar..." : "Registrera"}
                                </button>
                                
                                <div className="mt-4">
                                    <a href="/signIn" className="text-leaf hover:text-forest hover:underline text-sm">
                                        Har du redan ett konto? Logga in
                                    </a>
                                </div>
                            </form>
                            
                            {/* Footer */}
                            <div className="mt-8 pt-8 text-center w-full border-t border-sage">
                                <p className="text-sm text-brown">
                                    &copy; {new Date().getFullYear()} Naturborgarmärket
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
}
